export default "role-customer = Customer\nrole-driver = Driver\n\nyes = Yes\nnot = Not"